export default __webpack_public_path__ + "static/media/place_of_work_preview.0dfdaac8.png";